import { render, staticRenderFns } from "./write-canvas.vue?vue&type=template&id=b3217530&scoped=true&"
import script from "./write-canvas.vue?vue&type=script&lang=js&"
export * from "./write-canvas.vue?vue&type=script&lang=js&"
import style0 from "./write-canvas.vue?vue&type=style&index=0&id=b3217530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3217530",
  null
  
)

export default component.exports